import { InAppNotificationType } from 'pure-js/enums/InAppNotificationType'
import type { GameReminderPayload, InAppNotification } from 'pure-js/types/InAppNotification'
import { SidebarSection } from '../../../shared/types/navigation'
import { isGameReminderInShowWindow, isGameReminderPastStart } from '../../../shared/utils/gameReminderVisibility'

export const getFacilitatorSidebarNotificationSection = (
  notification: Pick<InAppNotification, 'type'>
): SidebarSection | null => {
  switch (notification.type) {
    case InAppNotificationType.GAME_REMINDER:
      return SidebarSection.SESSIONS
    case InAppNotificationType.REPORT_READY:
      return SidebarSection.DOWNLOAD_REPORTS
    default:
      return null
  }
}

export const shouldSurfaceFacilitatorSidebarNotification = (
  notification: InAppNotification,
  nowMs: number
): boolean => {
  if (notification.viewedAt) {
    return false
  }

  if (notification.type !== InAppNotificationType.GAME_REMINDER) {
    return getFacilitatorSidebarNotificationSection(notification) !== null
  }

  const payload = notification.payload as GameReminderPayload
  return isGameReminderInShowWindow(payload, nowMs) || isGameReminderPastStart(payload, nowMs)
}

export const buildFacilitatorSidebarNotificationCounts = (
  notifications: InAppNotification[],
  nowMs: number
): Partial<Record<SidebarSection, number>> => {
  return notifications.reduce<Partial<Record<SidebarSection, number>>>((counts, notification) => {
    if (!shouldSurfaceFacilitatorSidebarNotification(notification, nowMs)) {
      return counts
    }

    const section = getFacilitatorSidebarNotificationSection(notification)
    if (!section) {
      return counts
    }

    counts[section] = (counts[section] ?? 0) + 1
    return counts
  }, {})
}
